const setCoinSpend = (value: number): void => {
  const currentCointSpend = Number(sessionStorage.getItem('tgem-spend') || '0');
  const sum = currentCointSpend + value;
  sessionStorage.setItem('tgem-spend', String(sum));
};

export { setCoinSpend };
